import axios from 'axios';
import type { CourseData } from '../types/course';

const api = axios.create({
  baseURL: '/api',
});

export async function fetchCourses(): Promise<CourseData> {
  try {
    const response = await api.get('get_courses');
    return response.data.message;
  } catch (error) {
    console.error('Error in fetchCourses:', error);
    // Re-throw to handle in the store
    throw error;
  }
}

// Add a new function to fetch room modal settings
export async function fetchRoomModalSettings(): Promise<boolean> {
  try {
    const response = await api.get('https://frappe.kry.bz/api/method/bmapp.utils.api.get_room_modal_enabled');
    return response.data.message || false;
  } catch (error) {
    console.error('Error fetching room modal settings:', error);
    // Re-throw to handle in App.vue
    // throw error;
    return false;
  }
}